export default __webpack_public_path__ + "static/media/mid.ec849be2.svg";